import {RootState} from "../../app/store";

export const selectNoteById = (state: RootState, id: number) => state.notes.notes.find((note) => note.id === id)
